import { ValidationService } from 'aspnet-client-validation'

export default function () {
    var queryString = window.location.search;
    const params = new URLSearchParams(queryString);

    const debug = parseInt(params.get("debugvalidation")) == 1 ? console : undefined;
    let v = new ValidationService(debug);
    var required = function (value, element) {
        // Handle single and multiple checkboxes:
        if (element.type.toLowerCase() === "checkbox" || element.type.toLowerCase() === "radio") {
            var allCheckboxesOfThisName = element.form.querySelectorAll("input[name='" + element.name + "']");
            for (var i = 0; i < allCheckboxesOfThisName.length; i++) {

                if (allCheckboxesOfThisName[i].checked === true) {
                    return true;
                }
            }
            return false;
        }
        return Boolean(value);
    }
    v.addProvider("requiredcb", required);
    v.addProvider("required", required);// this will go instead of the build-in required.

    v.bootstrap({ watch: true });
    window.v = v;        
}